import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dvisualization',
  templateUrl: './datavisualization.component.html',
  styleUrls: ['./datavisualization.component.scss']
})
export class DataVisualizationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
